function initFilterSearchInputs() {
  document.querySelectorAll('.filter-search-input').forEach(function (input) {
    input.addEventListener('input', function (event) {
      event.stopPropagation();

      const searchTerm = this.value.toLowerCase();
      const filterName = this.getAttribute('data-filter-name');
      const filterList = document.querySelector(`.filter-values-list[data-filter-name="${CSS.escape(filterName)}"]`);

      if (filterList) {
        const items = filterList.querySelectorAll('.facets__item');
        items.forEach(function (item) {
          const rawValue = item.getAttribute('data-value') || '';
          const value = rawValue.toLowerCase();

          if (value.includes(searchTerm)) {
            item.classList.remove('hidden-by-search');
          } else {
            item.classList.add('hidden-by-search');
          }
        });
      }
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initFilterSearchInputs);

document.addEventListener('shopify:section:load', function (event) {
  if (event.target.querySelector('.filter-search-input')) {
    initFilterSearchInputs();
  }
});
